export const getCrmMeta = (crmType, catalogEntry) => ({
    id: crmType,
    label: catalogEntry?.label ?? crmType ?? 'CRM',
    authType: catalogEntry?.authType ?? 'oauth',
    requiresSubdomain: catalogEntry?.requiresSubdomain ?? false,
    logo: catalogEntry?.logo ?? null,
    primary: catalogEntry?.colors?.primary ?? '#90A4AE',
    border: catalogEntry?.colors?.border ?? '#90A4AE',
});

export const isApiKeyCrm = (crmType, catalogEntry) => getCrmMeta(crmType, catalogEntry).authType === 'api_key';
